import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const AdminApplicationService = {};

AdminApplicationService.getAllApplications = async function (page, limit) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/application/get",
        params: {
            page: page,
            limit: limit
        },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

AdminApplicationService.getApplicationsByStatus = async function (status) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/application/get-by-status",
        params: {
            status: status
        },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

AdminApplicationService.updateApplicationStatus = async function (id, status) {
    let data = new FormData();
    data.append("status", status);

    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/application/update-status/${id}`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

AdminApplicationService.getContractDraft = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/application/${id}/contract-draft`,
        responseType: 'blob',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

AdminApplicationService.deleteApplication = async function (id) {
    return axios({
        method: "delete",
        url: API_BASE_URL + `/api/admin/application/${id}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default AdminApplicationService;